import React, { useState } from 'react'

import { InputField, CheckboxInput, DropDownMenu, ModalAlert } from '@reactiveonline/reactive_admin_shared-packages'

export default function CompletedCard({
  canManageInvoicingOnboarding, apiIntegrationSettings, stores,
  notifyCustomerForApiKeysPath, saveApiIntegrationKeysPath, invoicingOnboarding,
  loading, setLoading, flashMessageRef, taxDocuments
}) {
  const [apiKey, setApiKey] = useState(apiIntegrationSettings?.api_key || '')
  const [series, setSeries] = useState(apiIntegrationSettings?.series || '')
  const [testMode, setTestMode] = useState((apiIntegrationSettings.test_mode && apiIntegrationSettings.test_mode !== '0') || false)

  const informedCustomerSetting = invoicingOnboarding.settings ? invoicingOnboarding.settings.find( setting => setting.key === 'customer_notification' ) : null

  const [informedCustomer, setInformedCustomer] = useState(informedCustomerSetting?.value === 'true')
  const [showNotifyCustomerAlert, setShowNotifyCustomerAlert] = useState(false)

  const statementDropdownActions = [
    { icon: 'fa-envelope', action: () => setShowNotifyCustomerAlert(true), text: ReactiveCore.translations.invoicing_onboarding.inform_customer, permissions: true },
    { icon: 'fa-circle-check', action: handleSaveApiIntegrationKeys, text: ReactiveCore.translations.invoicing_onboarding.save, permissions: true }
  ]

  function handleNotifyCustomerForApiKeys() {
    setLoading(true)

    Rails.ajax({
      type: 'POST',
      dataType: 'json',
      url: notifyCustomerForApiKeysPath,
      success: res => {
        setShowNotifyCustomerAlert(false)
        setLoading(false)
        setInformedCustomer(true)
        flashMessageRef.current.show(res.message, 'success')
      }
    })
  }

  function handleSaveApiIntegrationKeys() {
    setLoading(true)

    let fd = new FormData()
    fd.append('settings', JSON.stringify({
      api_key: apiKey.replace(/ /g, ''),
      series: series.replace(/ /g, ''),
      test_mode: testMode
    }))

    Rails.ajax({
      type: 'POST',
      url: saveApiIntegrationKeysPath,
      dataType: 'json',
      data: fd,
      success: res => {
        flashMessageRef.current.show(res.message, 'success')
      },
      error: res => {
        flashMessageRef.current.show(res.errors, 'error')
      },
      complete: res => {
        setLoading(false)
      }
    })
  }

  return (
    <>
      <div className='card onboarding-wrapper'>
        <div className='flex-box content-space-between items-center'>
          <div className='onboarding-title'>
            { ReactiveCore.translations.invoicing_onboarding.account_enabled }
          </div>

          <DropDownMenu
            items={ statementDropdownActions }
            title={ ReactiveCore.translations.invoicing_onboarding.actions }
          />
        </div>

        { informedCustomer &&
          <div className='onboarding-subtitle mt5 mb10'>
            { ReactiveCore.translations.invoicing_onboarding.customer_informed }
          </div>
        }

        <InputField label={ ReactiveCore.translations.invoicing_onboarding.api_key }>
          <input
            type='text'
            value={ canManageInvoicingOnboarding ? apiKey : (apiKey.length > 0 ? apiKey.substring(0, 8) + '...' : '' ) }
            onChange={ event => setApiKey(event.target.value) }
            className={ !canManageInvoicingOnboarding ? 'disabled' : '' }
            disabled={ !canManageInvoicingOnboarding }
          />
        </InputField>

        { series && (
          <InputField label={ ReactiveCore.translations.invoicing_onboarding.series }>
            <input
              type='text'
              value={ series }
              onChange={ event => setSeries(event.target.value) }
              className={ !canManageInvoicingOnboarding ? 'disabled' : ''}
              disabled={ !canManageInvoicingOnboarding }
            />
          </InputField>
        ) }

        { taxDocuments && (
          <>
            <InputField label={ ReactiveCore.translations.totalTaxDocuments }>
              <input
                type='text'
                value={ taxDocuments.total }
                disabled
              />
            </InputField>

            <InputField label={ ReactiveCore.translations.remainingTaxDocuments }>
              <input
                type='text'
                value={ taxDocuments.remaining }
                disabled
              />
            </InputField>
          </>
        ) }

        { canManageInvoicingOnboarding &&
          <CheckboxInput
            label='Test mode'
            checked={ testMode }
            setChecked={ checked => setTestMode(checked) }
          />
        }

        { stores && stores.length > 0 &&
          <div className='flex-box flex-column m-b-20'>
            <div className='input-field'><label>{ ReactiveCore.translations.invoicing_onboarding.issuer_branches }</label></div>
            <div className='flex-box flex-wrap' style={{ gap: 20 }}>
              { stores.map( (store, index)=> {
                return (
                  <div key={index} className='flex-box flex-1'>
                    <div className='m-r-10'>{ store.translations[0].title }</div>
                    <div className='bold'>{ store.invoice_issuer_branch }</div>
                  </div>
                )
              })}
            </div>

            <div className='input-field'><label>{ ReactiveCore.translations.invoicing_onboarding.series }</label></div>
            <div className='flex-box flex-wrap' style={{ gap: 20 }}>
              { stores.map( (store, index)=> {
                return (
                  <div key={index} className='flex-box flex-1'>
                    <div className='m-r-10'>{ store.translations[0].title }</div>
                    <div className='bold'>{ store.invoice_series }</div>
                  </div>
                )
              })}
            </div>
          </div>
        }
      </div>

      { showNotifyCustomerAlert &&
        <ModalAlert
          cancelText={ ReactiveCore.translations.invoicing_onboarding.cancel }
          acceptText={ ReactiveCore.translations.invoicing_onboarding.accept }
          alert={ ReactiveCore.translations.invoicing_onboarding.notify_customer_alert }
          onSelect={ handleNotifyCustomerForApiKeys }
          onClose={ () => setShowNotifyCustomerAlert(false) }
        />
      }
    </>
  )
}
